import script from "./RequestFormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestFormView.vue?vue&type=script&setup=true&lang=ts"

import "./RequestFormView.vue?vue&type=style&index=0&id=6c9fb22c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9fb22c"]])

export default __exports__